'use client';

//import bg from '../../../../public/images/background.svg'
import Image from "next/image";
import ButtonComponent from '../../components/Button';
import { useState } from 'react';
import axiosInstance from '@/app/utils/axiosInstance';
export default function Login() {
  // disable eslint for this line until it's used
  // eslint-disable-next-line
  const [id, setId] = useState('');
  const [notFound, setNotFound] = useState(false);
  const handleId = (event: any) => {
    setId(event.target.value);
  };
  const login = async () => {
    console.log(id);
    try {
      const user = await axiosInstance.get(`/users/${id}`);
      if (user.data.data !== null) {
        localStorage.setItem('userId', id);
        document.cookie = `userId=${id}`;
        window.location.href = '/consultation/form';
      } else {
        setNotFound(true);
      }
    } catch {
      setNotFound(true);
    }
  };
  const goBack = () => {
    window.history.back();
  };
  return <div className="bg-fixed bg-cover bg-center p-8 h-full min-h-screen" data-sentry-component="Login" data-sentry-source-file="page.tsx">
            <div className="max-w-screen-lg mx-auto flex flex-col items-center pt-8">
                <div className="w-[60%] md:w-[250px]">
                    <Image src="/images/logo.svg" alt="logo-ecole-ideale" width={300} height={300} className="w-full" data-sentry-element="Image" data-sentry-source-file="page.tsx" />
                </div>
                <h1 className="font-axiforma font-bold text-center py-16 text-xl md:text-3xl">Entrez votre code participant.e</h1>
                <p className="text-justify">
                    Le code participant unique attribué lors de votre précédente visite vous permet de repartir de là où vous vous étiez arrêté(e).
                    Entrez-le dans le champs ci-dessous et poursuivez la consultation :
                </p>
                <div className="flex justify-center w-full">
                    <input type="text" placeholder="Entrez votre code ici" className="border border-black p-2 my-8 w-full max-w-md" onChange={handleId}></input>
                </div>
                {notFound ? <p className="text-highlight">Oups ! Aucun utilisateur n'a été trouvé avec cet identifiant.</p> : ''}
                <div className="flex gap-8 py-8 justify-center w-full">
                    <ButtonComponent onClick={goBack} variant="white" text="RETOUR" data-sentry-element="ButtonComponent" data-sentry-source-file="page.tsx" />
                    <ButtonComponent onClick={login} variant="black" text="VALIDER" data-sentry-element="ButtonComponent" data-sentry-source-file="page.tsx" />
                </div>
            </div>
        </div>;
}